import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const MinusIconSvg = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2497 10.8213H4.39258"
      stroke="#8342C4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MinusIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={MinusIconSvg} {...props} />
);

export default MinusIcon;

MinusIcon.displayName = "MinusIcon";
